import { render } from "./uiGrid.vue?vue&type=template&id=1829d57e"
import script from "./uiGrid.vue?vue&type=script&lang=js"
export * from "./uiGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__